import gql from 'graphql-tag';

export const EXTERNAL_LOGIN = gql`
  mutation($externalToken: String!) {
    externalLogin(
      externalToken: $externalToken
    ) {
      jwt
      refreshToken
      orgId
      # session {}
      token
      tosRequired
      externalId
      userType
    }
  }
`;
